export default __webpack_public_path__ + "static/media/1.509d4d79.jpg";